import React from 'react'

const Header = () => {
    return(
        <header className='header_prof'>
            <img
                src='/assets/logo_white.webp'
                alt='Logo'
                className= 'logo-white'
            />
        </header>
    )   
}

export default Header